import { requestGet } from 'utils/request';
import { handleErrors } from '@tcc/scarecrow';

const BASE_URL = '/static/assets';

export const supportInfoRequest = () =>
  requestGet(`${BASE_URL}/public-data/support.json`).then(handleErrors);
